var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { removeTimezone } from '../../Common/utils/removeTimezone';
import { postprocessAssignmentName } from './postprocessAssignmentName';
var handleDates = function (dates) {
    return {
        startDate: removeTimezone(dates[0]),
        endDate: removeTimezone(dates[1]),
    };
};
export var handleCreateAssignmentFormData = function (data) {
    var name = data.name, dates = data.dates, students = data.students, skills = data.skills, cards = data.cards, rest = __rest(data, ["name", "dates", "students", "skills", "cards"]);
    return __assign(__assign(__assign(__assign({}, rest), { name: postprocessAssignmentName(name) }), handleDates(dates)), { studentIds: students.map(function (el) { return el.id; }), skillIds: skills.map(function (el) { return el.id; }), cardIds: cards.map(function (el) { return el.id; }) });
};
export var handleUpdateAssignmentFormData = function (data) {
    var dates = data.dates, name = data.name, rest = __rest(data, ["dates", "name"]);
    if (dates) {
        return __assign(__assign(__assign({}, rest), { name: name ? postprocessAssignmentName(name) : undefined }), handleDates(dates));
    }
    return data;
};
